var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurundi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.9542 31.0457 -0.000106812 20 -0.000106812C8.9543 -0.000106812 0 8.9542 0 19.9999C0 31.0456 8.9543 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1779 4.13297C25.0176 -1.37687 14.9826 -1.37687 7.82227 4.13289L20.0001 16.3107L32.1779 4.13297Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 23.6893L7.82227 35.867C14.9826 41.3768 25.0176 41.3768 32.1779 35.867L20.0001 23.6892L19.9999 23.6893Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3107 20L4.13299 7.82216C-1.37685 14.9825 -1.37685 25.0175 4.13299 32.1778L16.3107 20Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6893 20L35.867 32.1778C41.3768 25.0175 41.3768 14.9825 35.867 7.82216L23.6893 20Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 28.6956C24.8024 28.6956 28.6956 24.8025 28.6956 20C28.6956 15.1975 24.8024 11.3044 19.9999 11.3044C15.1975 11.3044 11.3043 15.1975 11.3043 20C11.3043 24.8025 15.1975 28.6956 19.9999 28.6956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.913L20.753 15.2174H22.2592L21.5061 16.5217L22.2592 17.8261H20.753L20 19.1305L19.2469 17.8261H17.7408L18.4939 16.5217L17.7408 15.2174H19.2469L20 13.913Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1722 20L16.9252 21.3044H18.4313L17.6783 22.6087L18.4313 23.9131H16.9252L16.1722 25.2175L15.4191 23.9131H13.913L14.666 22.6087L13.913 21.3044H15.4191L16.1722 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8277 20L24.5807 21.3044H26.0868L25.3338 22.6087L26.0868 23.9131H24.5807L23.8277 25.2175L23.0746 23.9131H21.5685L22.3215 22.6087L21.5685 21.3044H23.0746L23.8277 20Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurundi);
export default __webpack_public_path__ + "static/media/burundi.bd5f07ebee73fb06599401a279e65e4e.svg";
export { ForwardRef as ReactComponent };